const PhoneNumber = require('awesome-phonenumber');
export const defaultMask = '+## # ## ## ## ## ## ## ## ## ##';

export function unmask(telephone) {
  if (telephone) {
    return telephone.replaceAll(' ', '');
  }
  if (telephone === '') {
    return null;
  }
  return telephone;
}

export function copieTelephone(target, value) {
  target.libelle = value.libelle || null;
  target.numero = value.numero || null;
  target.confidentiel = value.confidentiel || null;
  target.smsAccepte = value.smsAccepte || null;
  target.codePoste = value.codePoste || null;
  return target;
}

export function getInternational(number) {
  if (!number) return number;
  var international = PhoneNumber(number).getNumber('international');
  if (!international) return number;
  return international;
}

export function getmask(number) {
  if (number) {
    var international = PhoneNumber(number).getNumber('international');
    if (international) {
      return [international.replace(/\d/g, '#'), defaultMask];
    }
  }
  return defaultMask;
}
